// Frontend Sentry init. No-op when VITE_SENTRY_DSN is unset/empty,
// so dev builds and any build without the env wired stay quiet.
//
// To enable in prod: pass --build-arg VITE_SENTRY_DSN=<dsn> in
// cloudbuild.yaml (the Vite plugin substitutes VITE_* at build time).

import * as Sentry from "@sentry/react";

declare const __SENTRY_DSN__: string;

let initialized = false;

export function initSpaSentry() {
  if (initialized) return;
  const dsn = (typeof __SENTRY_DSN__ === "string" ? __SENTRY_DSN__ : "").trim();
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_GIT_SHA || undefined,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
  initialized = true;
}

export { Sentry };
